/*eslint-disable no-unused-vars */
import axios from 'axios';
import CryptoJS from 'crypto-js';
import base64url from 'base64url';
import APIEndpoints from '../../api/APIEndpoints';
import HttpHeader from '../httpheader';
import RetryAPI from '../../api/RetryAPI';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import apiDecrypt from '../Decrypt';

class CreateJWToken {
  cacheBuster = (url) => `${url}?cb=${Date.now()}`;
  constructor() {
    this.encodePayload = '';
    this.symmetricKey = '';
    this.domainOid = '';
    this.jwt = '';
  }

  getBase64EncodedPayload() {
    return this.encodePayload;
  }

  setBase64EncodedPayload(payload) {
    this.encodePayload = payload;
  }

  async createJWToken(flowName) {
    const createJWT = await Promise.all([
      this.getDomainOidSymmetricKey(flowName),
    ]);

    return this.jwt;
  }

  getJWTToken() {
    return this.jwt;
  }

  async getDomainOidSymmetricKey(flowName) {
    let keyStoreResp = null;
    let keyStoreDataResp = null;

    try {
      const CreateJWTAPI = axios.create({
        headers: {
          //Authorization: "",
          'X-ClientID': HttpHeader.getCNAME(),
          Accept: 'application/json',
          //'X-DeviceID' : HttpHeader.getDevice()
        },
      });
      console.log(CreateJWTAPI, 'CreateJWTAPI');
      const EncryptedKeyStoreResp = await CreateJWTAPI.get(
        this.cacheBuster(APIEndpoints.getKeyStoreResources()),
      );
      console.log(EncryptedKeyStoreResp, 'EncryptedKeyStoreResp');
      keyStoreResp = EncryptedKeyStoreResp;
      keyStoreDataResp = apiDecrypt(EncryptedKeyStoreResp.data);
      console.log('keyStoreResp: ', keyStoreResp);
      if (keyStoreResp.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        console.log('Get Key Store RESPONSE Received ==== : ', keyStoreResp);
        this.setDomainOid(keyStoreDataResp.Response.DomainOid);
        this.setsymmetricKey(keyStoreDataResp.Response.SymmetricKey);
        console.log('Get Domain Oid ==== : ', this.getDomainOid());
        console.log('Get Symmetric Key ==== : ', this.getSymmetricKey());
        this.formulatePayload(flowName);
        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(keyStoreResp.status);
        console.log('Get Key Store RESPONSE failed', keyStoreResp);
      }
    } catch (error) {
      let errorMessage = '';
      let requestAborted = '';

      console.log('Get Key Store RESPONSE Exception: ', error);

      if (error) {
        errorMessage = error.toString();
        requestAborted = errorMessage.match(/aborted/i);
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        console.log('Data: ', error.response.data);
        console.log('Header: ', error.response.headers);
        console.log('Status: ', error.response.status);
        RetryAPI.setErrorCode(error.response.status);
      }

      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);
    }
    return keyStoreResp;
  }

  getDomainOid() {
    return this.domainOid;
  }

  setDomainOid(domainOid) {
    this.domainOid = domainOid;
  }

  getSymmetricKey() {
    return this.symmetricKey;
  }

  setsymmetricKey(symmetricKey) {
    this.symmetricKey = symmetricKey;
  }

  formulatePayload(flowName) {
    const header = {
      typ: 'JWT',
      alg: 'HS256',
    };

    const payloadObj = {
      iss: 'Portal-' + HttpHeader.getCNAME(),

      exp: Date.now() + 1800000,

      custom: {
        flow_name: flowName,

        domain_oid: this.getDomainOid(),
      },
    };
    console.log(payloadObj);
    //encode header
    const stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
    const encodedHeader = CryptoJS.enc.Base64.stringify(stringifiedHeader);
    const base64URLHeader = base64url.fromBase64(encodedHeader);
    //Encoding Payload
    const payloadJson = JSON.stringify(payloadObj);

    const payLoadWordArray = CryptoJS.enc.Utf8.parse(payloadJson);
    console.log(payLoadWordArray);
    const base64EncodedPayload =
      CryptoJS.enc.Base64.stringify(payLoadWordArray);
    this.encodePayload = base64url.fromBase64(base64EncodedPayload);

    console.log(this.encodePayload);

    //Decoding Payload Test
    //build token
    const token = base64URLHeader + '.' + this.encodePayload;

    const symmKey = CryptoJS.enc.Utf8.parse(this.symmetricKey);
    console.log(symmKey);
    const base64EncodedsymmKey = CryptoJS.enc.Base64.stringify(symmKey);
    const symmKeybase64url = base64url.fromBase64(base64EncodedsymmKey);

    const payloadSignature = CryptoJS.HmacSHA256(token, symmKeybase64url);
    console.log('payloadSignature: ', payloadSignature);
    const base64Signature = CryptoJS.enc.Base64.stringify(payloadSignature);
    console.log('base64Signature: ', base64Signature);
    const base64URLSignature = base64url.fromBase64(base64Signature);
    const jwt = token + '.' + base64URLSignature;
    console.log('JWT: ', jwt);
    this.jwt = jwt;
  }

  resetCreateJWToken() {
    this.AccountDetails = [];
    this.data = [];
    this.columns = [];
  }
}

export default new CreateJWToken();
